import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding Recap 50: How newbie mistakes kill the flow",
  "description": "",
  "published": "2017-11-06T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-recap-50-how-newbie-mistakes-kill-flow/swizec/7901"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should follow `}<a parentName="em" {...{
          "href": "https://www.youtube.com/TheSwizec"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <lite-youtube {...{
      "videoid": "7PVF41QHIK0",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Ah, it's good to be back. It's been what, a month? Long time no see as the first person to say hi in the chatroom said.`}</p>
    <p>{`We continued to work on `}<a parentName="p" {...{
        "href": "https://github.com/gatsbyjs/gatsby"
      }}>{`GatsbyJS`}</a>{`. That one feature I want to add: Make links in markdown tables of contents absolute.`}</p>
    <p>{`Instead of `}<inlineCode parentName="p">{`#some-title`}</inlineCode>{` the link should be `}<inlineCode parentName="p">{`/page-slug#some-title`}</inlineCode>{`. That way users can put tables of contents on their index pages and link into documents directly.`}</p>
    <p>{`The first difficulty was `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/wont-be-switching-vscode/swizec/7898"
      }}>{`using VSCode`}</a>{`. I wanted to give it a fairer shot at impressing me after all the configuration advice people gave me on Friday.`}</p>
    <p>{`Also, this killer feature looks cool and I want it.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`plus then you can slowly learn to become hopelessly dependent on this feature: `}<a parentName="p" {...{
          "href": "https://t.co/U0kUwijD6j"
        }}>{`pic.twitter.com/U0kUwijD6j`}</a></p>{`— Jason Miller 🦊⚛ (@_developit) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/_developit/status/926509015672160256"
      }}>{`November 3, 2017`}</a></blockquote>
    <p>{`I'll talk more about VSCode after I use it some more.`}</p>
    <p>{`The other difficulty was that I have no idea what I'm doing. At first, I was editing the wrong file. My code kept vanishing every time compilation did its thing.`}</p>
    <p>{`Turns out there's a big difference between `}<inlineCode parentName="p">{`gatsby-transform-remark/extend-node-type.js`}</inlineCode>{` and `}<inlineCode parentName="p">{`gatsby-transform-remark/src/extend-node-type.js`}</inlineCode>{`.`}</p>
    <p>{`Confusing for a newbie that those two files are so close together, but it makes sense. Gatsby uses something called `}<a parentName="p" {...{
        "href": "https://github.com/lerna/lerna"
      }}>{`Lerna`}</a>{` to create a multirepo. Every folder inside the repository is its own package.`}</p>
    <p>{`When I figured that out, I had the bright idea to update my local clone to latest master.`}</p>
    <p>{`It did not go so well.`}</p>
    <p>{`It went so not well, in fact, that we never got to the real work. I don't know how many times I installed and reinstalled `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`, but nothing worked.`}</p>
    <p>{`This ate all the time I had, and we got nothing done.`}</p>
    <p>{`I mean, sure, we explored how the markdown AST stuff works, where we need to add the slug (it's deep inside children of children), and made a reasonable hypothesis that we can get the slug using `}<inlineCode parentName="p">{`markdownNode.fields.slug`}</inlineCode>{`.`}</p>
    <p>{`The hypothesis stems from this: We know that each Gatsby node has a `}<inlineCode parentName="p">{`fields.slug`}</inlineCode>{`. Don't know where it comes from, but docs assure us it's there. Not sure `}<inlineCode parentName="p">{`markdownNode`}</inlineCode>{` is `}<em parentName="p">{`that`}</em>{` node, but what else could it be?`}</p>
    <p><inlineCode parentName="p">{`markdownNode`}</inlineCode>{` is the node that we are extending, therefore it must be the same thing as a normal Gatsby node. It's just called `}<inlineCode parentName="p">{`markdownNode`}</inlineCode>{` here because we're operating on markdown.`}</p>
    <p>{`This is the function we're tweaking by the way 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`async function getTableOfContents(markdownNode) {
  const cachedToc = await cache.get(tableOfContentsCacheKey(markdownNode));
  if (cachedToc) {
    return cachedToc;
  } else {
    const ast = await getAST(markdownNode);
    const tocAst = mdastToToc(ast);
    let toc;
    if (tocAst.map) {
      toc = hastToHTML(toHAST(tocAst.map));
    } else {
      toc = \`\`;
    }
    cache.set(tableOfContentsCacheKey(markdownNode), toc);
    return toc;
  }
}
`}</code></pre>
    <p>{`That `}<inlineCode parentName="p">{`tocAst`}</inlineCode>{` is where we inject our tweak. I think 🤔`}</p>
    <p>{`Oh right! The newbie mistake fix 👉 Matthew of Gatsby fame informed me that my `}<inlineCode parentName="p">{`yarn.lock`}</inlineCode>{` was probably out of date. It was.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      